const CONTACT_ONLY_KEYS = new Set(["kycEmail", "kycMobile"]);

export const normalizeKycStatusName = (statusName = "") =>
  String(statusName)
    .trim()
    .toUpperCase()
    .replace(/\s+/g, "_");

export const hasFullKycProgress = (kycDetails = {}) =>
  Object.entries(kycDetails).some(
    ([key, item]) =>
      !CONTACT_ONLY_KEYS.has(key) &&
      (item?.isVerified || item?.docValue || item?.docUrl),
  );

export const getKycStatusLabel = ({ kycDetails, statusName }) => {
  const normalized = normalizeKycStatusName(statusName);

  if (normalized === "KYC_VERIFIED") return "KYC Completed";
  if (normalized === "KYC_REVIEW") return "KYC Under Review";
  if (normalized === "KYC_PENDING") return "KYC Pending";

  if (hasFullKycProgress(kycDetails)) return "KYC In Progress";

  return "KYC Not Completed";
};

export const getKycStatusTagColor = (kycStatus) => {
  if (kycStatus === "KYC Completed") return "green";
  if (kycStatus === "KYC Under Review") return "blue";
  if (kycStatus === "KYC In Progress") return "gold";
  return "orange";
};

export const isKycSubmittedStatus = (statusName) => {
  const normalized = normalizeKycStatusName(statusName);
  return normalized === "KYC_VERIFIED" || normalized === "KYC_REVIEW";
};

export const shouldShowKycSuccessScreen = ({ statusName, isSubmitted, hasToken }) =>
  Boolean(hasToken) &&
  (isSubmitted || isKycSubmittedStatus(statusName));

export const getEffectiveKycStatusName = ({ statusName, isSubmitted, hasToken }) => {
  if (!hasToken && isSubmitted) return "KYC_VERIFIED";
  return statusName;
};

export const isCompleteKycReadOnly = ({ statusName, isSubmitted, hasToken }) => {
  if (shouldShowKycSuccessScreen({ statusName, isSubmitted, hasToken })) {
    return false;
  }
  if (!hasToken && isSubmitted) return true;
  return isKycSubmittedStatus(statusName);
};

/**
 * Second product (e.g. SCF after IF) already has org-level HyperVerge KYC.
 * Form is prefilled/read-only; admin only confirms checkbox and submits for this deal category.
 * A newly accepted enquiry (first product, KYC pending) must stay editable even if
 * PAN/GSTIN were verified during enquiry capture.
 */
export const isReusableKycConfirmMode = ({
  statusName,
  kycDetails,
  isSubmitted,
  hasToken,
  hasOtherCompletedKyc,
}) => {
  if (hasToken || isSubmitted) return false;
  if (!hasOtherCompletedKyc) return false;
  if (normalizeKycStatusName(statusName) !== "KYC_PENDING") return false;
  return Boolean(
    kycDetails?.kycPanValue?.isVerified &&
      kycDetails?.kycGstinValue?.isVerified,
  );
};
